$(document).ready(function(){
  $('.featured-collection__slider .product-grid').slick({
    dots: false,
    arrows: true,
    infinite: false,
    slidesToShow: 5,
    slidesToScroll: 1,
    prevArrow: '<div class="arrow-left"><svg width="13" height="5" viewBox="0 0 13 5" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.80384 4.92021C8.92384 4.60821 9.05584 4.32021 9.19984 4.05621C9.34384 3.78021 9.50584 3.52221 9.68584 3.28221H0.0378418V1.80621H9.68584C9.51784 1.56621 9.36184 1.31421 9.21784 1.05021C9.07384 0.774212 8.94184 0.480212 8.82184 0.168213H10.1898C10.9338 1.04421 11.7498 1.71021 12.6378 2.16621V2.94021C11.7498 3.37221 10.9338 4.03221 10.1898 4.92021H8.80384Z" fill="#161616"/></svg></div>',
    nextArrow: '<div class="arrow-right"><svg width="13" height="5" viewBox="0 0 13 5" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.80384 4.92021C8.92384 4.60821 9.05584 4.32021 9.19984 4.05621C9.34384 3.78021 9.50584 3.52221 9.68584 3.28221H0.0378418V1.80621H9.68584C9.51784 1.56621 9.36184 1.31421 9.21784 1.05021C9.07384 0.774212 8.94184 0.480212 8.82184 0.168213H10.1898C10.9338 1.04421 11.7498 1.71021 12.6378 2.16621V2.94021C11.7498 3.37221 10.9338 4.03221 10.1898 4.92021H8.80384Z" fill="#161616"/></svg> </div>',
    responsive: [
      {
        breakpoint: 1600,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 990,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 750,
        settings: {
          arrows: false,
          infinite: true,
          centerMode: true,
          centerPadding: '60px',
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });

  $('.featured-collections__slider').slick({
    dots: false,
    arrows: true,
    infinite: false,
    slidesToShow: 5,
    slidesToScroll: 1,
    prevArrow: '<div class="arrow-left"><svg width="13" height="5" viewBox="0 0 13 5" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.80384 4.92021C8.92384 4.60821 9.05584 4.32021 9.19984 4.05621C9.34384 3.78021 9.50584 3.52221 9.68584 3.28221H0.0378418V1.80621H9.68584C9.51784 1.56621 9.36184 1.31421 9.21784 1.05021C9.07384 0.774212 8.94184 0.480212 8.82184 0.168213H10.1898C10.9338 1.04421 11.7498 1.71021 12.6378 2.16621V2.94021C11.7498 3.37221 10.9338 4.03221 10.1898 4.92021H8.80384Z" fill="#161616"/></svg></div>',
    nextArrow: '<div class="arrow-right"><svg width="13" height="5" viewBox="0 0 13 5" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.80384 4.92021C8.92384 4.60821 9.05584 4.32021 9.19984 4.05621C9.34384 3.78021 9.50584 3.52221 9.68584 3.28221H0.0378418V1.80621H9.68584C9.51784 1.56621 9.36184 1.31421 9.21784 1.05021C9.07384 0.774212 8.94184 0.480212 8.82184 0.168213H10.1898C10.9338 1.04421 11.7498 1.71021 12.6378 2.16621V2.94021C11.7498 3.37221 10.9338 4.03221 10.1898 4.92021H8.80384Z" fill="#161616"/></svg> </div>',
    responsive: [
      {
        breakpoint: 1600,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 990,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 750,
        settings: {
          arrows: false,
          infinite: true,
          centerMode: true,
          centerPadding: '60px',
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
  
  $('.featured-collection__filter .tag').on('click', function(){
    $(this).parent().find('.tag').removeClass("active");
    $(this).addClass("active");
    var tag = $(this).data('tag');
    $(this).parents(".collection").find(".featured-collections__slider").hide();
    $("#"+tag+"__slider.featured-collections__slider").show();
    $("#"+tag+"__slider.featured-collections__slider").slick("slickAdd");
  });

  $(".featured-collection__filter-option .option").on('click', function(){
    $(".featured-collection__filter-option").hide();
    $(".featured-collection__filter").removeClass("active");
    $(this).parents(".featured-collection__filter").find(".featured-collection__filter-label span").text($(this).text());
    var tag = $(this).data('tag');
    $(this).parents(".collection").find(".featured-collections__slider").hide();
    $("#"+tag+"__slider.featured-collections__slider").show();
    $("#"+tag+"__slider.featured-collections__slider").slick("slickAdd");
  });

  $('.featured-collection__filter select').on('change', function(){
    var tag = $(this).val();
    $(this).parents(".collection").find(".featured-collections__slider").hide();
    $("#"+tag+"__slider.featured-collections__slider").show();
    $("#"+tag+"__slider.featured-collections__slider").slick("slickAdd");
  });

  $(".featured-collection__filter-label").click(function(){
    $(this).parent().toggleClass("active");
    $(this).parent().find(".featured-collection__filter-option").toggle();
  });

  // $('.featured-collection__filter .tag').on('click', function(){
  //   $(this).parent().find('.tag').removeClass("active");
  //   $(this).addClass("active");
  //   var tag = $(this).data('tag');
  //   if (tag.indexOf("all") > -1) {
  //     $(this).parents('.collection').find('.featured-collection__slider .product-grid').slick('slickUnfilter');
  //   }else{
  //     $(this).parents('.collection').find('.featured-collection__slider .product-grid').slick('slickUnfilter');
  //     $(this).parents('.collection').find('.featured-collection__slider .product-grid').slick('slickFilter', '.'+tag+'--tag');
  //   }
  // });

  // $('.featured-collection__filter select').on('change', function(){
  //   var tag = $(this).val();
  //   if (tag.indexOf("all") > -1) {
  //     $(this).parents('.collection').find('.featured-collection__slider .product-grid').slick('slickUnfilter');
  //   }else{
  //     $(this).parents('.collection').find('.featured-collection__slider .product-grid').slick('slickUnfilter');
  //     $(this).parents('.collection').find('.featured-collection__slider .product-grid').slick('slickFilter', '.'+tag+'--tag');
  //   }
  // });

  $(".testimonials-slider").slick({
    dots: false,
    arrows: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 990,
        settings: {
          dots: true,
          centerMode: true,
          centerPadding: '45px',
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 750,
        settings: {
          dots: true,
          centerMode: true,
          centerPadding: '45px'
        }
      }
    ]
  });
  $(".testimonials-slider__arrow-left").click(function(){
    $(".testimonials-slider").slick("slickPrev");
  });
  $(".testimonials-slider__arrow-right").click(function(){
    $(".testimonials-slider").slick("slickNext");
  });
  $(".testimonials-slider__dots .dot").click(function(){
    var i = $(this).data("index");
    $(".testimonials-slider").slick("slickGoTo", i);
  });
  $(".testimonials-slider").on("afterChange", function(event, slick, currentSlide, nextSlide){
    $(".testimonials-slider__dots .dot").removeClass("active");
    $(".testimonials-slider__dots .dot[data-index="+currentSlide+"]").addClass("active");
  });

  $('.related-blog__slider').slick({
    dots: false,
    arrows: false,
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    prevArrow: '<div class="arrow-left"><svg width="13" height="5" viewBox="0 0 13 5" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.80384 4.92021C8.92384 4.60821 9.05584 4.32021 9.19984 4.05621C9.34384 3.78021 9.50584 3.52221 9.68584 3.28221H0.0378418V1.80621H9.68584C9.51784 1.56621 9.36184 1.31421 9.21784 1.05021C9.07384 0.774212 8.94184 0.480212 8.82184 0.168213H10.1898C10.9338 1.04421 11.7498 1.71021 12.6378 2.16621V2.94021C11.7498 3.37221 10.9338 4.03221 10.1898 4.92021H8.80384Z" fill="#161616"/></svg></div>',
    nextArrow: '<div class="arrow-right"><svg width="13" height="5" viewBox="0 0 13 5" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.80384 4.92021C8.92384 4.60821 9.05584 4.32021 9.19984 4.05621C9.34384 3.78021 9.50584 3.52221 9.68584 3.28221H0.0378418V1.80621H9.68584C9.51784 1.56621 9.36184 1.31421 9.21784 1.05021C9.07384 0.774212 8.94184 0.480212 8.82184 0.168213H10.1898C10.9338 1.04421 11.7498 1.71021 12.6378 2.16621V2.94021C11.7498 3.37221 10.9338 4.03221 10.1898 4.92021H8.80384Z" fill="#161616"/></svg> </div>',
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 990,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 750,
        settings: {
          arrows: false,
          infinite: true,
          centerMode: true,
          centerPadding: '60px',
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });

  $(".cart-drawer__product-related").slick({
      dots: true,
      arrows: false,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1
  });

  $(".product-media__slider").slick({
      dots: false,
      arrows: false,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 750,
          settings: {
            dots: true
          }
        }
      ]
  });
  $(".product-media__slider").slick("slickAdd");
  $(".product-media__slider").on("beforeChange", function(event, slick, currentSlide, nextSlide){
    $(".product-media__count span").text(nextSlide+1);
  });
  $(".product-media__arrow .arrow-left").click(function(){
    $(".product-media__slider").slick("slickPrev");
  });
  $(".product-media__arrow .arrow-right").click(function(){
    $(".product-media__slider").slick("slickNext");
  });
  var l = $(".product-media__slider ul.slick-dots li").length;
  if(l == 1){
    $(".product-media__slider ul.slick-dots").hide();
  }


  if($(window).width() < 750){
    $(".image-banner-2").slick({
      dots: true,
      arrows: false,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1
    });
    
    $(".featured-blog__articles").slick({
      dots: true,
      arrows: false,
      infinite: true,
      centerMode: true,
      centerPadding: '45px',
      slidesToShow: 1,
      slidesToScroll: 1
    });

    $(".team-wrapper").slick({
      dots: true,
      arrows: false,
      infinite: true,
      centerMode: true,
      centerPadding: '45px',
      slidesToShow: 1,
      slidesToScroll: 1
    });

    $(".brewing-guide__images").slick({
      dots: true,
      arrows: false,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1
    });
  }

  if($(window).width() < 990){
    setTimeout(function(){
      var maxHeight = 0;
      $(".testimonials-slider .testimonial").each(function(){
        if ($(this).find(".testimonial-content").innerHeight() > maxHeight){
          maxHeight = $(this).find(".testimonial-content").innerHeight();
        }
      });
      $(".testimonial-content").css("min-height", maxHeight+"px");
    }, 500);
  }

  setTimeout(function(){
    $(".collection .product-grid .grid__item").slice(0, 12).show();
    $(".btn_loadmore").on('click', function (e) {
        e.preventDefault();
        $(".collection .product-grid .grid__item:hidden").slice(0, 12).slideDown();
        if ($(".collection .product-grid .grid__item:hidden").length == 0) {
            $(".collection__loadmore").fadeOut('slow');
        }
    });
  }, 10);

  $(".brew-guide__search input").on("input", function() {
    var v = $(this).val().toLowerCase();
    if(v != ''){
      $(".brew-guide__wrapper .brew-guide__item").each(function(){
        var title = $(this).find(".title").text().toLowerCase();
        if(title.indexOf(v) > -1){
          $(this).show();
        }else{
          $(this).hide();
        }
      });
    }else{
      $(".brew-guide__item").show();
    }
  });

  $(".faqs__page-search input").on("input", function() {
    var v = $(this).val().toLowerCase();
    if(v != ''){
      var c = 0;
      $(".faqs__heading").hide();
      $(".faqs__button").hide();
      $(".faqs__wrapper .faqs__item").each(function(){
        var title = $(this).find(".faqs__title").text().toLowerCase();
        if(title.indexOf(v) > -1){
          $(this).show();
          $(this).parents(".faqs").find(".faqs__heading").show();
          c = c + 1;
        }else{
          $(this).hide();
        }
      });
      if(c == 0){
        $(".faqs__no-result span").text(v);
        $(".faqs__no-result").show();
      }else{
        $(".faqs__no-result").hide();
      }
    }else{
      $(".faqs__no-result").hide();
      $(".faqs__heading").show();
      $(".faqs__item").show();
      $(".faqs__button").show();
    }
  });

  $(".blog-articles.has-loadmore .blog-articles__article").slice(0, 16).show();
  $(".btn-loadmore").on('click', function (e) {
        e.preventDefault();
        $(".blog-articles.has-loadmore .blog-articles__article:hidden").slice(0, 16).slideDown();
        if ($(".blog-articles.has-loadmore .blog-articles__article:hidden").length == 0) {
            $(".blog-articles__loadmore").fadeOut('slow');
        }
  });

  if($(window).width() > 1440){
    var padding = ($(window).width() - 1425) / 2;
    //$(".featured-collection__slider").css("margin-left", padding+"px");
    //$(".featured-collections__slider").css("margin-left", padding+"px");
    $(".related-blog__slider").css("margin-left", padding+"px");
  }

  $(".collection-hero__select .current-tag").click(function(){
    $(this).parent().toggleClass("open");
    $(this).parent().find("ul").slideToggle();
  });
});

$(window).resize(function(){
  if($(window).width() > 1440){
    var padding = ($(window).width() - 1425) / 2;
    //$(".featured-collection__slider").css("margin-left", padding+"px");
    //$(".featured-collections__slider").css("margin-left", padding+"px");
    $(".related-blog__slider").css("margin-left", padding+"px");
  }else{
    $(".featured-collection__slider").css("margin-left", "0px");
    $(".featured-collections__slider").css("margin-left", "0px");
    $(".related-blog__slider").css("margin-left", "0px");
  }
});

$(document).mouseup(function(e) {
    var container = $(".featured-collection__filter");
    if (!container.is(e.target) && container.has(e.target).length === 0) {
        container.removeClass("active");
        container.find(".featured-collection__filter-option").hide();
    }
});

$(document).ready(function(){
	 var lastScrollTop = 0, delta = 5;
	 $(window).scroll(function(){
		 var nowScrollTop = $(this).scrollTop();
		 if(Math.abs(lastScrollTop - nowScrollTop) >= delta){
		 	if (nowScrollTop > lastScrollTop){
               $('.back-to-top').fadeOut();
		 	} else {
              if($(window).scrollTop() + $(window).height() > $(document).height() - 1000){
		 		$('.back-to-top').fadeIn();
              }else{
                $('.back-to-top').fadeOut();
              }
			}
		 lastScrollTop = nowScrollTop;
		 }
	 });
      $('.back-to-top').click(function(){
        $('html, body').animate({scrollTop : 0},800);
        return false;
    });
 });

 $(window).scroll(function(){
   var load = $('.collection__loadmore');
   if (load.length) {
     var position = load.position();
     if($(window).width() > 749){
       var h = position.top - 500;
     }else{
       var h = position.top - 300;
     }
     if($(this).scrollTop() >= h){
       $(".btn_loadmore").trigger("click");
     }
   }
 });